import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Select from '../../../../../components/input/Select';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Img from '../../../../../components/Img';
import Slider from '../../../../../components/utils/Slider';
import {
  MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT,
  ORDER_RETURN_ITEM_TYPE_SELECT_LIST,
  ORDER_RETURN_ITEM_TYPE_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import './EditReturnReasonModal.scss';

const EditReturnReasonModal = (props) => {
  const { form, isOpen, data, onSubmit, setData, closeModal, reasonType, reason } = props;
  const { orderItemInfo, returnAttachments } = data;
  const { orderItemId, productName, productPrice, returnType, returnReason } = orderItemInfo;

  return (
    <Modal
      title="반품 사유 수정"
      isOpen={isOpen}
      width={600}
      height={510}
      isFooter={true}
      okText="반품 사유 수정"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="edit-return-reason-modal-wrap">
        <div className="title">선택된 상품 주문 리스트</div>

        <InfoTable>
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="title">변경하기 전 내역</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">기존 반품 사유</td>
              <td className="tl" colSpan={3}>
                {ORDER_RETURN_ITEM_TYPE_TEXT[returnType]}
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>기존 상세 사유</span>
              </td>
              <td className="tl" colSpan={3}>
                {returnReason}
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="title">변경할 내역</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">반품 사유 선택</td>
              <td className="tl" colSpan={3}>
                <Select
                  list={ORDER_RETURN_ITEM_TYPE_SELECT_LIST}
                  onChange={(id) =>
                    setData({
                      name: 'reasonType',
                      value: id,
                    })
                  }
                  value={reasonType}
                  size="default"
                  isTable={true}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>상세 사유 입력</span>
                <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={reason}
                  onChange={(value) =>
                    setData({
                      name: 'reason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        {/*반품 요청 사진이 없으면 렌더링하지 않는다.*/}
        {returnAttachments.length > 0 ? (
          <Fragment>
            <div className="title">반품 요청 상세 이미지</div>
            <div className="img-area">
              <Slider
                list={returnAttachments}
                // customPaging={(slide) =>
                //     <div className="dot-class">
                //         <img src={returnAttachments[slide]}/>
                //     </div>
                // }
                item={(url) => <Img height={500} src={url} />}
              />
            </div>
          </Fragment>
        ) : undefined}
      </div>
    </Modal>
  );
};

export default EditReturnReasonModal;
